var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"historic-main-screen__right-side"},[_c('RightSideLotsList',{attrs:{"auctionData":this.auctionDataParent}}),_vm._v(" "),_c('RightSideAlertNotCurrentLot',{attrs:{"auctionData":this.auctionDataParent,"wsListener":this.wsListener}}),_vm._v(" "),_c('RightSideItemContent',{attrs:{"auctionData":this.auctionDataParent}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-429f16cd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/right-side/right-side.vue
// module id = null
// module chunks = 